module.exports = __webpack_public_path__ + "img/bg04.f331f23f.png";